/* eslint-disable no-restricted-syntax,guard-for-in,no-unused-vars */
import _ from 'lodash';
import GuestAffiliation from '../components/manage/guestlist/GuestAffiliation';
import * as ActionTypes from '../actions/types/SeatingChartActionTypes';

const initialState = {
  selectedGuests: [],
  expandableGuestGroup: {},
  couple: {},
  guestGroupings: null,
  groupingNames: {}
};

const guestRailReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.RECEIVE_CHART: {
      const selectedGuests = [];
      const seatingChart = action.payload.data;
      const coupleObj = seatingChart.guests.couple;
      const couple = {
        primary: {
          firstName: coupleObj.primary_first_name,
          lastName: coupleObj.primary_last_name,
          seat_uuid: coupleObj.primary_seat_uuid,
          table_uuid: coupleObj.primary_table_uuid,
          role: 'OWNER'
        },
        partner: {
          firstName: coupleObj.partner_first_name,
          lastName: coupleObj.partner_last_name,
          seat_uuid: coupleObj.partner_seat_uuid,
          table_uuid: coupleObj.partner_table_uuid,
          role: 'PARTNER'
        }
      };

      const guestGroupings = seatingChart.guests.guest_list;
      const groupingIdentifiesPopulated = !_.isEmpty(state.groupingNames);
      if (!groupingIdentifiesPopulated) {
        const expandableGuestGroup = { WEDDING_COUPLE: true, ...state.expandableGuestGroup };
        const guestAffiliation = GuestAffiliation(coupleObj.primary_first_name, coupleObj.partner_first_name);
        for (const prop in guestGroupings) {
          expandableGuestGroup[prop] = false;
        }

        const groupingNames = { WEDDING_COUPLE: 'The Happy Couple' };
        for (let i = 0; i < guestAffiliation.length; i += 1) {
          const affiliation = guestAffiliation[i].value;
          groupingNames[affiliation] = affiliation === 'UNKNOWN' ? 'Other' : guestAffiliation[i].title;
        }

        return Object.assign(
            {},
            state,
            { guestGroupings, groupingNames, expandableGuestGroup, couple, selectedGuests }
        );
      }

      return Object.assign(
        {},
        state,
        { couple, guestGroupings, selectedGuests }
      );
    }
    case ActionTypes.SELECT_GUESTS: {
      let selectedGuests = [...state.selectedGuests];
      const guest = action.payload.guest;
      let guestId;
      if (guest.guest_view != null) {
        guestId = guest.guest_view.id;
      } else {
        guestId = guest.role === 'OWNER' ? -1 : -2;
      }
      const guestGroup = action.payload.guestGroup;
      const isChecked = _.includes(selectedGuests, guestId);
      if (isChecked) {
        selectedGuests = _.without(selectedGuests, guestId);
      } else {
        selectedGuests.push(guestId);
        if (guestGroup !== 'couple' && guest.guest_view.relationship_type === 'PRIMARY') {
          for (let i = 0; i < guestGroup.guests.length; i += 1) {
            const isSeated = guest.table_uuid != null;
            const additionalGuest = guestGroup.guests[i].guest_view;
            if (additionalGuest != null) {
              const checked = _.includes(selectedGuests, additionalGuest.id);
              if (!isSeated && !checked) {
                selectedGuests.push(additionalGuest.id);
              }
            }
          }
        }
      }
      return Object.assign(
        {},
        state,
        { selectedGuests }
      );
    }
    case ActionTypes.EXPAND_GUEST_GROUP: {
      const expandableGuestGroup = { ...state.expandableGuestGroup };
      expandableGuestGroup[action.payload.guestGroup] = !expandableGuestGroup[action.payload.guestGroup];
      return Object.assign(
        {},
        state,
        { expandableGuestGroup }
      );
    }
    default: return state;
  }
};

export default guestRailReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/guestRail.js
 **/